import React from 'react';

const FormField = ({ label, children, className = '', labelStyle, style }) => {
  return (
    <div className={className} style={style}>
      <label className="ui-form-label" style={labelStyle}>{label}</label>
      {children}
    </div>
  );
};

export default FormField;